export default {"src":"/_next/static/media/journal-2.b9ac0864.svg","height":219,"width":177};